module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('view-box', [_c('div', {
    staticClass: "body",
    staticStyle: {
      "height": "100%",
      "overflow": "auto"
    }
  }, [_c('m-column', {
    attrs: {
      "title": "保单查询"
    }
  }, [_c('div', {
    slot: "right"
  }, [_c('x-input', {
    staticClass: "padding-right-0",
    attrs: {
      "max": 18,
      "show-clear": false,
      "placeholder": "请输入投保人身份证号",
      "placeholder-align": "right",
      "text-align": "right"
    },
    on: {
      "on-blur": _vm.toUpper
    },
    model: {
      value: (_vm.holderIDNumber),
      callback: function($$v) {
        _vm.holderIDNumber = $$v
      },
      expression: "holderIDNumber"
    }
  }, [_c('x-button', {
    staticStyle: {
      "margin-left": "4px",
      "padding-left": "8px",
      "padding-right": "8px"
    },
    attrs: {
      "type": "primary",
      "mini": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.getOrders($event)
      }
    },
    slot: "right"
  }, [_vm._v("点击查询")])], 1)], 1)]), _vm._v(" "), _c('m-column', {
    staticStyle: {
      "margin": "10px 0"
    },
    attrs: {
      "title": "选择保单"
    }
  }, [_c('div', {
    slot: "right"
  }, [_c('popup-picker', {
    staticClass: "padding-right-0",
    attrs: {
      "before-show": _vm.beforeShow,
      "display-format": _vm.formatOrderDisplay,
      "title": "",
      "data": _vm.orderList,
      "columns": 1,
      "placeholder": _vm.orderPlaceholder
    },
    on: {
      "on-change": _vm.onChangeOrder
    },
    model: {
      value: (_vm.currentOrder),
      callback: function($$v) {
        _vm.currentOrder = $$v
      },
      expression: "currentOrder"
    }
  })], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.currentOrderDetail.length),
      expression: "currentOrderDetail.length"
    }],
    slot: "body"
  }, [_c('group', {
    attrs: {
      "gutter": "0"
    }
  }, _vm._l((_vm.currentOrderDetail), function(item, index) {
    return _c('cell', {
      key: index,
      attrs: {
        "title": item.name
      }
    }, [_vm._v(_vm._s(item.value))])
  }))], 1)]), _vm._v(" "), _c('m-column', {
    staticStyle: {
      "margin": "10px 0"
    },
    attrs: {
      "title": "确认升级信息"
    }
  }, [_c('div', {
    slot: "body"
  }, [_c('group', {
    attrs: {
      "gutter": "0"
    }
  }, [_c('cell', {
    attrs: {
      "title": "轻症额度"
    }
  }, [_vm._v(_vm._s(_vm.qzLimit || '自动计算'))]), _vm._v(" "), _c('cell', {
    attrs: {
      "title": "轻症保费"
    }
  }, [_vm._v(_vm._s(_vm.qzPremium ? _vm.qzPremium + '元' : '自动计算'))])], 1)], 1)]), _vm._v(" "), _c('m-agree-iterms', {
    staticStyle: {
      "margin": "10px 0"
    },
    model: {
      value: (_vm.agreeTerms),
      callback: function($$v) {
        _vm.agreeTerms = $$v
      },
      expression: "agreeTerms"
    }
  }, [_c('div', {
    slot: "body"
  }, [_c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.agreement)
    }
  })])])], 1), _vm._v(" "), _c('tabbar', {
    slot: "bottom"
  }, [_c('div', {
    staticClass: "bottom"
  }, [_c('div', {
    staticClass: "price"
  }, [_c('p', [_vm._v("价格："), _c('label', {
    staticClass: "mark"
  }, [_vm._v("￥"), _c('span', {
    staticClass: "payment"
  }, [_vm._v(_vm._s(_vm.qzPremium2))]), _vm._v("/年"), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.qzPremiumOK),
      expression: "!qzPremiumOK"
    }]
  }, [_vm._v(" 起")])])])]), _vm._v(" "), _c('div', {
    staticClass: "btn theme-bg-color",
    on: {
      "click": _vm.submitOrder
    }
  }, [_c('span', [_vm._v("提交订单")])])])]), _vm._v(" "), _c('m-login', {
    attrs: {
      "showLogin": _vm.showLogin
    },
    on: {
      "close": _vm.closeLogin
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-43a00930","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vux-loader/src/before-template-compiler-loader.js!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/customs/GuoHuaQingZhengForm.vue
// module id = 660
// module chunks = 1